/* Box sizing rules */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Prevent font size inflation */
html {
  -moz-text-size-adjust: none;
  -webkit-text-size-adjust: none;
  text-size-adjust: none;
}

/* Remove default margin in favour of better control in authored CSS */
body, h1, h2, h3, h4, p,
figure, blockquote, dl, dd {
  margin-block-start: 0;
  margin-block-end: 0;
}

/* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
ul[role=list],
ol[role=list] {
  list-style: none;
}

/* Set core body defaults */
body {
  min-height: 100vh;
  line-height: 1.5;
  margin: 0;
}

/* Set shorter line heights on headings and interactive elements */
h1, h2, h3, h4,
button, input, label {
  line-height: 1.1;
}

/* Balance text wrapping on headings */
h1, h2,
h3, h4 {
  text-wrap: balance;
}

/* A elements that don't have a class get default styles */
a:not([class]) {
  text-decoration-skip-ink: auto;
  color: currentColor;
}

/* Make images easier to work with */
img,
picture {
  max-width: 100%;
  display: block;
}

/* Inherit fonts for inputs and buttons */
input, button,
textarea, select {
  font-family: inherit;
  font-size: inherit;
}

/* Make sure textareas without a rows attribute are not tiny */
textarea:not([rows]) {
  min-height: 10em;
}

/* Anything that has been anchored to should have extra scroll margin */
:target {
  scroll-margin-block: 5ex;
}

/* Remove margins on p tags */
p {
  margin-block-start: 0;
}

@keyframes blurReveal {
  0% {
    opacity: 0;
    filter: blur(8px);
    transform: translateY(15px);
  }
  100% {
    opacity: 1;
    filter: blur(0px);
    transform: translateY(0);
  }
}
@keyframes moveUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100px);
  }
}
img.lazy {
  filter: blur(5px);
}

.coxtainer {
  display: grid;
  width: 100%;
  grid-template-columns: minmax(20px, 1fr) minmax(100px, 1160px) minmax(20px, 1fr);
}
.coxtainer > * {
  grid-column: 2/3;
}
.coxtainer > .full-width {
  grid-column: 1/4;
}

@font-face {
  font-family: "Fatfrank";
  src: url("../fonts/fatfrank/FatFrank-Regular.eot");
  src: url("../fonts/fatfrank/FatFrank-Regular.eot?") format("embedded-opentype"), url("../fonts/fatfrank/FatFrank-Regular.woff") format("woff"), url("../fonts/fatfrank/FatFrank-Regular.ttf") format("opentype");
  font-weight: normal;
  font-style: normal;
}
h1, h2, h3 {
  font-family: "FatFrank", asap, "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: regular;
  font-weight: 400;
}

#main p {
  margin-bottom: 1.5em;
}

.absolute-header .header_wrapper {
  z-index: 100;
  width: 100%;
}

.absolute-header .header_wrapper {
  position: absolute;
  left: 0;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  height: 150px;
}
header .logo {
  width: 300px;
}
header .menu {
  display: none;
  font-family: "FatFrank", asap, "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: regular;
  transition: background;
}
@media (min-width: 1024px) {
  header .menu {
    display: flex;
    text-align: right;
    padding-top: 1rem;
    flex-direction: row;
    column-gap: 1em;
  }
}
header .menu .navbar-item {
  padding-top: 0.6rem;
}
header .menu a {
  text-decoration: none;
}
header .hamburger {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
  width: 30px;
}
@media (min-width: 1024px) {
  header .hamburger {
    display: none;
  }
}
header .hamburger__bun-top, header .hamburger__patty, header .hamburger__bun-bottom {
  background: var(--header-colour);
  width: 100%;
  height: 3px;
  transform-origin: 50% 50%;
  transition: transform 0.3s ease-out;
}
header .hamburger--open {
  z-index: 201;
}
header .hamburger--open .hamburger__patty {
  display: none;
}
header .hamburger--open .hamburger__bun-top {
  transform: rotate(45deg) translateY(5px);
}
header .hamburger--open .hamburger__bun-bottom {
  transform: rotate(-45deg) translateY(-6px);
}

.menu-mobile {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-family: "FatFrank", asap, "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: regular;
  transition: background;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  z-index: 20;
  font-size: 32px;
  animation: menu-fade-in 0.5s ease-out;
}
.menu-mobile--open {
  display: flex;
}
@media (min-width: 1024px) {
  .menu-mobile {
    display: none;
  }
}
.menu-mobile .navbar-item {
  padding-top: 0.6rem;
}
.menu-mobile a {
  text-decoration: none;
  color: #fff;
  animation: menu-item-fade-in 0.3s ease-out;
  animation-fill-mode: backwards;
  animation-delay: 0.1s;
}
.menu-mobile a:nth-child(2) {
  animation-delay: 0.15s;
}
.menu-mobile a:nth-child(3) {
  animation-delay: 0.2s;
}
.menu-mobile a:nth-child(4) {
  animation-delay: 0.25s;
}
.menu-mobile a:nth-child(5) {
  animation-delay: 0.3s;
}
.menu-mobile a:nth-child(6) {
  animation-delay: 0.35s;
}
.menu-mobile a:nth-child(7) {
  animation-delay: 0.4s;
}

@keyframes menu-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes menu-item-fade-in {
  0% {
    opacity: 0;
    transform: scale(1.5) translateX(100px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateX(0px);
  }
}
.logo #ghost {
  -webkit-animation: bob 1.5s cubic-bezier(0.37, 0, 0.63, 1) infinite alternate;
  animation: bob 1.5s cubic-bezier(0.37, 0, 0.63, 1) infinite alternate;
}
.logo #ghost #lid1, .logo #ghost #lid2 {
  animation: blink 3.3s infinite;
  stroke: var(--header-colour);
  fill: var(--header-colour);
}
.logo #ghost #pupil1, .logo #ghost #pupil2 {
  fill: var(--header-colour);
}
.logo #ghost #eye1, .logo #ghost #eye2 {
  stroke: var(--header-colour);
}
.logo #ghost #body path {
  stroke: var(--header-colour);
}
.logo #ghost #body polygon {
  fill: var(--header-colour);
}
.logo #type path {
  fill: var(--header-colour);
}

@keyframes bob {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(10px);
  }
}
@keyframes blink {
  94% {
    opacity: 0;
  }
  95% {
    opacity: 1;
  }
  96% {
    opacity: 1;
  }
  97% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
.standard__header {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-top: 150px;
  margin-bottom: 100px;
}
.standard__header__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  animation: work-header 0.2s ease-out;
}
.standard__header__text {
  font-family: "FatFrank", asap, "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: regular;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}
.standard__header__text h1 {
  margin-top: 0;
}
.standard__header__text .standard__header__intro,
.standard__header__text .standard__header__intro p {
  font-size: 3rem;
}
.password-form {
  padding: 20px;
  margin-bottom: 20px;
  border: 2px dashed var(--text-colour);
  border-radius: 10px;
  text-align: center;
}
.password-form p {
  font-weight: 600;
  margin-bottom: 10px;
}
.password-form input[type=password], .password-form input[type=submit] {
  background: transparent;
  border: 1px solid var(--text-colour);
  color: var(--text-colour);
  font-weight: 600;
  font-size: 18px;
  border-radius: 4px;
  padding: 10px 20px;
}
.password-form input[type=submit] {
  background: var(--text-colour);
  color: var(--bg-colour);
}

.works {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.works__item {
  position: relative;
  aspect-ratio: 1.618/1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  overflow: hidden;
  border-radius: 8px;
}
@media (min-width: 1024px) {
  .works__item {
    aspect-ratio: 3/1;
  }
}
.works__item h2 {
  position: relative;
  z-index: 3;
  transition: transform 0.3s ease-out;
}
@media (min-width: 1024px) {
  .works__item h2 {
    opacity: 0;
    transform: translateY(200px);
  }
}
.works__item img, .works__item__cover {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #000;
}
.works__item img {
  object-fit: cover;
  object-alignment: center;
}
.works__item__cover {
  z-index: 2;
  opacity: 0.617;
  transition: opacity 0.2s ease-out;
}
@media (min-width: 1024px) {
  .works__item__cover {
    opacity: 0;
  }
}
.works__item:hover h2 {
  opacity: 1;
  transform: translateY(0);
}
.works__item:hover .works__item__cover {
  opacity: 0.617;
}
.works__item--private {
  background: rgba(0, 0, 0, 0.2);
}
.works__item--private svg {
  width: 64px;
}
.works__item--private svg path {
  stroke: var(--text-colour);
}
.works__item--private h2 {
  opacity: 1;
  transform: none;
}

.home__header {
  margin-top: 75px;
  margin-bottom: 100px;
  min-height: 200px;
}
@media (min-width: 769px) {
  .home__header {
    margin-top: 150px;
    margin-bottom: 200px;
  }
}
.home__header h1 {
  display: block;
  font-size: 2em;
  line-height: 1.2;
  font-weight: 100;
  text-align: center;
  animation: moveUp linear both;
  animation-timeline: view();
  /* Base styles for the words */
}
@media (min-width: 769px) {
  .home__header h1 {
    font-size: 3.5em;
    line-height: 1.2;
  }
}
.home__header h1 strong {
  opacity: 0.75;
}
.home__header h1 .word {
  display: inline-block;
  opacity: 0;
  filter: blur(8px);
  transform: translateY(15px);
  /* The magic happens here: multiplying the index by a delay */
  animation: blurReveal 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
  animation-delay: calc(var(--word-index) * 0.04s);
}

/**
 * Single portfolio item
 */
:root {
  --height-difference: 0px;
  --anim-speed: 2s;
}

.work__nav {
  position: absolute;
  z-index: 10;
  top: 50%;
  transform: translateY(-50%);
}
.work__nav svg {
  width: 40px;
  height: auto;
  transition: fill 0.3s ease;
  transform: scaleY(-1) rotate(-120deg);
}
.work__nav svg path {
  fill: var(--text-colour);
}
.work__nav a {
  font-size: 12px;
  text-decoration: none;
  color: var(--color-text);
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.work__nav--pevious {
  left: 20px;
}
.work__nav--next {
  right: 20px;
}
.work__nav--next svg {
  transform: scaleY(1) rotate(50deg);
}
.work__chrome {
  width: 100%;
  aspect-ratio: 16/9;
  background-repeat: no-repeat;
  background-position: top left;
  background-size: cover;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.4);
}
.work__chrome__address {
  color: #999;
  position: absolute;
  z-index: 2;
  top: 3%;
  left: 14%;
  font-size: clamp(10px, 2.3cqw, 20px);
}
@media (min-width: 769px) {
  .work__chrome__address {
    font-size: clamp(10px, 1.15cqw, 20px);
  }
}
@media (min-width: 1024px) {
  .work__chrome__address {
    font-size: 14px;
    top: 8px;
  }
}
.work__chrome__image {
  position: absolute;
  z-index: 1;
  top: 12%;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.work__chrome__image img {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  animation: work-chrome var(--anim-speed) ease-out infinite;
}
@keyframes work-chrome {
  0% {
    top: 0;
  }
  5% {
    top: 0;
  }
  75% {
    top: var(--height-difference);
  }
  100% {
    top: 0;
  }
}
.work__header {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-top: 150px;
  margin-bottom: 100px;
}
.work__header__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 50px;
  animation: work-header 0.2s ease-out;
}
@media (min-width: 769px) {
  .work__header__grid {
    grid-template-columns: 1fr 1fr;
  }
}
.work__header__text {
  font-family: "FatFrank", asap, "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: regular;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}
.work__header__text h1 {
  margin-top: 0;
}
.work__header__text a {
  opacity: 0.5;
  transition: opacity 0.3s ease;
  text-decoration: none;
}
.work__header__text a:hover {
  opacity: 1;
}
.work__header__text .work__header__intro {
  opacity: 0.75;
}
@keyframes work-header {
  0% {
    opacity: 0;
    transform: translateY(100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
.about__header {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-top: 150px;
  margin-bottom: 100px;
}
.about__header__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  animation: work-header 0.2s ease-out;
}
.about__header__text {
  font-family: "FatFrank", asap, "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: regular;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}
.about__header__text h1 {
  margin-top: 0;
}
.about__header__text .about__header__intro {
  font-size: 3rem;
}
.blog-listing__grid__item {
  text-decoration: none;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}
@media (min-width: 769px) {
  .blog-listing__grid__item {
    grid-template-columns: 1fr 1fr;
  }
}
.blog-listing__grid__item img {
  width: 100%;
  height: auto;
  border-radius: 15px;
}

.cox-block {
  margin-bottom: 100px;
}

/*_     _     _     _     _            _    
| |   (_)___| |_  | |__ | | ___   ___| | __
| |   | / __| __| | '_ \| |/ _ \ / __| |/ /
| |___| \__ \ |_  | |_) | | (_) | (__|   < 
|_____|_|___/\__| |_.__/|_|\___/ \___|_|\_*/
.list-columns-block ul {
  padding: 0;
  display: grid;
  gap: 25px;
}
.list-columns-block ul li {
  list-style: none;
  font-size: 16px;
  font-weight: 600;
}
.list-columns-block--split-1 ul {
  grid-template-columns: 1fr;
}
.list-columns-block--split-2 ul {
  grid-template-columns: 1fr 1fr;
}
.list-columns-block--split-3 ul {
  grid-template-columns: 1fr 1fr 1fr;
}

/*_____        __      ____     __     
|_   _|____  _| |_   / ___|___ | |___ 
  | |/ _ \ \/ / __| | |   / _ \| / __|
  | |  __/>  <| |_  | |__| (_) | \__ \
  |_|\___/_/\_\\__|  \____\___/|_|__*/
.text-columns-block h1, .text-columns-block h2, .text-columns-block h3 {
  text-align: center;
  margin-bottom: 50px;
}
.text-columns-block__cols {
  display: grid;
  gap: 25px;
}
.text-columns-block__cols--1 {
  grid-template-columns: 1fr;
}
.text-columns-block__cols--2 {
  grid-template-columns: 1fr 1fr;
}

/*_____         _     ___                 
|_   _|____  _| |_  |_ _|_ __ ___   __ _ 
  | |/ _ \ \/ / __|  | || '_ ` _ \ / _` |
  | |  __/>  <| |_   | || | | | | | (_| |
  |_|\___/_/\_\\__| |___|_| |_| |_|\__, |
                                   |__*/
.text-image-block__cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 5rem;
}
.text-image-block__cols__col__image img {
  width: 100%;
  height: auto;
}

/*___                            
|_ _|_ __ ___   __ _  __ _  ___ 
 | || '_ ` _ \ / _` |/ _` |/ _ \
 | || | | | | | (_| | (_| |  __/
|___|_| |_| |_|\__,_|\__, |\___|
                     |__*/
.image-block figure {
  margin: 0;
}
.image-block figure img {
  width: 100%;
  height: auto;
}
.image-block--full-width {
  grid-column: 1/4;
}

:root {
  --text-colour: #f1cfbc;
  --header-colour: #f1cfbc;
  --bg-colour: #134140;
}

body {
  font-family: "Montserrat", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 1.25rem;
  background: var(--bg-colour);
  color: var(--text-colour);
  border: brown;
}
@media (max-width: 1024px) {
  body {
    font-size: 1rem;
  }
}
body a {
  color: white;
}

#main {
  view-transition-name: main;
}

ul.messages {
  z-index: 102;
  padding: 0;
}
ul.messages li {
  color: var(--bg-colour);
  background: var(--text-colour);
  padding: 20px;
  border-radius: 8px;
}

@view-transition {
  navigation: auto;
}
/* Create a custom animation */
@keyframes move-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes move-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
::view-transition-old(main) {
  animation: 1s ease-in both move-out;
}

::view-transition-new(main) {
  animation: 1s ease-in both move-in;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */